import { cn } from '@/lib/utils'
import logoSvg from '@/assets/svg/logo.svg'

interface LogoProps {
  className?: string
  showText?: boolean
}

const Logo = ({ className, showText = true }: LogoProps) => {
  return (
    <div className={cn('flex items-center', className)}>
      <img src={logoSvg} alt="Fenra" className="h-8 w-8" />
      {showText && <span className='ml-3 text-xl font-bold'>Fenra</span>}
    </div>
  )
}

export default Logo

